<div class="main-div">
    <p class="mainHeading">{{ 'RAIN-METER-SELECTION-DIALOG.TITLE' | translate }}</p>

    <div class="buttonGroup flex-row space-around-center gap-10">
        <button class="sort-btn flex-50" mat-flat-button (click)="sortByName()">{{ 'RAIN-METER-SELECTION-DIALOG.SORT-BY-NAME' | translate }}</button>
        <button class="sort-btn flex-50" mat-flat-button (click)="sortByDistance()">{{ 'RAIN-METER-SELECTION-DIALOG.SORT-BY-DISTANCE' | translate }}</button>
    </div>
    <hr />

    <div class="rain-meter-list">
        <div *ngFor="let rainMeter of rainMeters" class="listDiv"
            (click)="selectRainMeter(rainMeter.id, rainMeter.name)">
            <div class="flex-row space-between gap-10">
                <label class="rainMeterHeading">{{ rainMeter.name }}</label>
                <label> {{ rainMeter.distance | number:'1.0-0'}}m</label>
            </div>
            <div class="itemDiv flex-row space-between gap-10">
                <label>{{ rainMeter.description }}</label>
            </div>
        </div>
    </div>

    <hr class="hr"/>

    <div>
        <button  mat-flat-button type="button"  class="cancel-rain-meter-btn" (click)="closeDialog()">{{ 'DATE-RANGE-DIALOG.CANCEL' | translate }}</button>
    </div>
</div>
